import {
  AllessehQueryRules,
  AllessehQuerySortKeyTypes,
  AllessehQuerySortOrderType
} from 'hooks/useAllessehContentQuery';

export const DEFAULT_PRODUCT_VALUE = ['Barrons.com'];

export const COMMON_QUERY_RULES_CONFIG: AllessehQueryRules = {
  and: [{ terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } }],
  not: []
};

export const DEFAULT_SORT_CONFIG = [
  { key: AllessehQuerySortKeyTypes.LiveDate, order: AllessehQuerySortOrderType.DESC }
];

export const COMMON_VIDEO_QUERY_RULES_CONFIG: AllessehQueryRules = {
  and: [
    { term: { key: 'ContentType', value: 'video' } },
    { terms: { key: 'Product', value: ['Barrons Broadband Video'] } }
  ]
};

export const COMMON_AUDIO_QUERY_RULES_CONFIG: AllessehQueryRules = {
  and: [
    { term: { key: 'ContentType', value: 'audio' } },
    { terms: { key: 'Product', value: ['Barrons Broadband Podcast'] } }
  ]
};

export const COMMON_QUERY_CONFIG = {
  sort: DEFAULT_SORT_CONFIG
};

export const DEFAULT_LIMIT = 5;

export const BASE_QUERY = {
  query: {
    and: [{ terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } }],
    not: [
      {
        terms: {
          key: 'SectionName',
          value: ['Corrections and Amplifications', 'Decos and Corrections']
        }
      }
    ]
  },
  sort: [{ key: AllessehQuerySortKeyTypes.LiveDate, order: AllessehQuerySortOrderType.DESC }],
  count: DEFAULT_LIMIT
};
